export const noticeForPrice =
  '価格は変更されることがあり、実際と異なる場合があります。また、近隣地域の墓石制作・工事費を元にライフドット独自で算出した価格が一部含まれています。最新の価格等を知りたい場合は、資料請求にてご確認ください。'
